import "../../assets/scss/create-target.scss";

import { useAuth } from "../../hooks/useAuth";
import { useQuery } from "react-query";
import {
  customerFullName,
  fetchActionsUtil,
  formatDateTime,
  getCustomerFirstAndLastName,
  getIncentive,
  paginationOptions,
} from "../../utils/helpers";

import currency from "currency.js";
import TableComponent from "../TableComponent";
import { Button, Modal, ProgressBar } from "react-bootstrap";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Badge } from "react-bootstrap";
import TargetIncentiveEarningHistory from "./TargetIncentiveEarningHistory";
import CachedIcon from "mdi-react/CachedIcon";

const STATUS_CONFIG = {
  "in-progress": { label: "In Progress", variant: "primary" },
  met: { label: "Met", variant: "success" },
  exceeded: { label: "Exceeded", variant: "info" },
  "not-met": { label: "Not Met", variant: "danger" },
};

function TargetStatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || {
    label: status || "Unknown",
    variant: "secondary",
  };

  return <Badge bg={config.variant}>{config.label}</Badge>;
}

const TargetPerformanceModal = ({ show, setShow, title, id, type }) => {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
  });
  const [details, setDetails] = useState({
    userId: "",
    targetOccurrenceId: "",
    user: "",
    title: "",
  });
  const [showHistory, setShowHistory] = useState(false);

  const { data, refetch } = useQuery(
    ["VIEW_TARGET_PERFORMANCE", id, queryParams],

    () =>
      fetchActionsUtil(
        `${backendUrl}/api/company/target-performance-users?targetOccurrenceId=${id}&page=${
          queryParams.page
        }&limit=${queryParams.limit}`,
      ),
    { onSuccess: (data) => {} },
    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>Target Title</th>
          <th>Customer Name</th>
          <th>Target Amount</th>
          <th>Amount Realized</th>
          <th>Success Rate</th>
          <th>Status</th>
          {/* <th>Incentive Type (Met)</th> */}
          <th>Incentive Amount (Met)</th>

          {/* <th>Incentive Type (Exceeded)</th> */}
          <th>Incentive Amount (Exceeded)</th>

          {/* <th>Incentive Type (Not Met)</th> */}
          <th>Incentive Amount (Not Met)</th>
          <th>Payroll Status</th>
          <th>Action</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{el?.targetTitle ?? ""} </td>
        <td>{getCustomerFirstAndLastName(el?.customers)}</td>
        <td>
          {el?.metricType === "revenue"
            ? currency(el?.targetAmount).format({
                symbol: "",
                separator: ",",
              })
            : `${el?.targetAmount} ${el?.metricType}`}
        </td>
        <td>
          {currency(Number(el?.total)).format({ symbol: "", separator: "" })}
        </td>
        <td>
          <ProgressBar
            now={Number(el?.progress)}
            label={`${Number(el?.progress)}%`}
          />
        </td>
        <td>
          <TargetStatusBadge status={el?.status} />
        </td>
        <td>
          {Boolean(Number(el?.enableIncentive))
            ? getIncentive({
                metricType: el?.metricType,
                incentiveValue: el?.incentiveValue,
                incentiveType: el?.incentiveType,
              })
            : "..."}
          <div>
            <b>
              {currency(el?.payout?.baseIncentiveAmount).format({
                symbol: "",
                separator: ",",
              })}
            </b>
          </div>
        </td>
        <td>
          {Boolean(Number(el?.enableIncentive))
            ? getIncentive({
                metricType: el?.metricType,
                incentiveValue: el?.exceededIncentiveValue,
                incentiveType: el?.exceededIncentiveType,
              })
            : "..."}
          {Boolean(Number(el?.enableIncentive)) ? (
            <div>
              <b>
                {currency(el?.payout?.exceededIncentiveAmount).format({
                  symbol: "",
                  separator: ",",
                })}
              </b>
            </div>
          ) : (
            "..."
          )}
        </td>
        <td>
          {Boolean(Number(el?.enableNotMetIncentive))
            ? getIncentive({
                metricType: el?.metricType,
                incentiveValue: el?.notMetIncentiveValue,
                incentiveType: el?.notMetIncentiveType,
              })
            : "..."}
          {Boolean(Number(el?.enableNotMetIncentive)) ? (
            <div>
              <b>
                {currency(el?.payout?.notMetIncentiveAmount).format({
                  symbol: "",
                  separator: ",",
                })}
              </b>
            </div>
          ) : (
            "..."
          )}
        </td>
        <td>
          {el?.linkIncentiveToPayroll && el?.isPaymentProcessed
            ? "Processed"
            : "..."}
        </td>
        <td>
          <Button
            variant=""
            className="btn btn-print border "
            size="sm"
            style={{ whiteSpace: "normal" }}
          >
            History
          </Button>
        </td>
      </>
    );
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  function manageTransaction(e, el) {
    setDetails({
      user: getCustomerFirstAndLastName(el?.customers),
      userId: el.userId,
      targetOccurrenceId: el.targetOccurrenceId,
      title: el?.targetTitle,
      target: el,
    });
    setShowHistory(true);
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered={true}
        animation={false}
        enforceFocus={false}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h6>
              Customers/Sales Rep Target Performance{" "}
              <CachedIcon onClick={() => refetch()} />
            </h6>
            <p className={"subtitle"}>
              View the performance of each customer/sales rep
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={"container"}>
            <div className="px-md-4">
              <TableComponent
                responsive
                borderless
                striped
                // style={{ tableLayout: "fixed" }}
                tableHeadsFunction={tableHead}
                mainDataArray={data?.data || []}
                className="product-table  table-fixed"
                tableDataRowFunction={tableData}
                tableRowClick={(e, el) => manageTransaction(e, el)}
              />
            </div>

            <div className="d-flex justify-content-between px-3 align-items-center pagination">
              {/*<p className="m-0">
                            Showing {data?.startIndex + 1} to{" "}
                            {data?.endIndex <= data?.count ? data?.endIndex : data?.count}{" "}
                            of {data.count} entries
                              </p> */}
              <div className="pagination_left">
                <p className="m-0 p-0">Show</p>
                <select
                  value={queryParams.limit}
                  name="limit"
                  className="form-select "
                  onChange={(e) => handleSearchQueryChange(e)}
                >
                  <option value="10">10 rows</option>
                  <option value="20">20 rows</option>
                  <option value="30">30 rows</option>
                  <option value="40">40 rows</option>
                  <option value="50">50 rows</option>
                  <option value="100">100 rows</option>{" "}
                </select>
              </div>

              <ReactPaginate
                {...paginationOptions}
                pageCount={Math.ceil(data?.count / queryParams.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={0}
                onPageChange={({ selected }) => {
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  setQueryParams({
                    ...queryParams,
                    page: selected + 1,
                  });
                }}
                forcePage={queryParams.page - 1}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {showHistory && (
        <TargetIncentiveEarningHistory
          {...details}
          show={showHistory}
          setShow={setShowHistory}
        />
      )}
    </>
  );
};

export default TargetPerformanceModal;
